import { render, staticRenderFns } from "./BilletExcelObjectsPie.vue?vue&type=template&id=21c5d736"
import script from "./BilletExcelObjectsPie.vue?vue&type=script&lang=js"
export * from "./BilletExcelObjectsPie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports